import * as React from 'react'
import { ReactComponent as DefaultLogo } from '../../assets/images/svg_icons/t2p-logo-color.svg'

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return <DefaultLogo />
}

export default SvgComponent
